
import React from "react";
import { Button } from "@/components/ui/button";
import { X, Save } from "lucide-react";

interface FormHeaderProps {
  isSubmitting: boolean;
  onCancel: () => void;
  onSave: () => void;
}

const FormHeader: React.FC<FormHeaderProps> = ({ isSubmitting, onCancel, onSave }) => {
  return (
    <div className="flex justify-between items-center mb-4">
      <h2 className="text-xl font-bold text-energy-green-dark">Editar Gerador</h2>
      <div className="flex space-x-2">
        <Button 
          variant="outline" 
          size="sm" 
          onClick={onCancel}
          className="border-muted-foreground text-muted-foreground"
        >
          <X className="h-4 w-4 mr-2" />
          Cancelar
        </Button>
        <Button 
          size="sm"
          className="bg-energy-green text-white hover:bg-energy-green-dark"
          onClick={onSave}
          disabled={isSubmitting}
        >
          <Save className="h-4 w-4 mr-2" />
          {isSubmitting ? "Salvando..." : "Salvar"}
        </Button>
      </div>
    </div>
  );
};

export default FormHeader;
